var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('VantEmpty',{attrs:{"description":_vm.assetsConfig.no_content || '暂无内容，敬请期待。'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }